/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TermsOfUseImport } from './routes/terms-of-use'
import { Route as PrivacyPolicyImport } from './routes/privacy-policy'
import { Route as ContactSupportImport } from './routes/contact-support'
import { Route as AuthenticatedImport } from './routes/_authenticated'
import { Route as IndexImport } from './routes/index'
import { Route as SignInIndexImport } from './routes/sign-in/index'
import { Route as LoginIndexImport } from './routes/login/index'
import { Route as ForgotPasswordIndexImport } from './routes/forgot-password/index'
import { Route as PasswordSetupAuthTokenImport } from './routes/password-setup/$authToken'
import { Route as PasswordChangeAuthTokenImport } from './routes/password-change/$authToken'
import { Route as AuthenticatedUserImport } from './routes/_authenticated/_user'
import { Route as AuthenticatedPeerSupportImport } from './routes/_authenticated/_peer-support'
import { Route as AuthenticatedOrganizationImport } from './routes/_authenticated/_organization'
import { Route as AuthenticatedOnboardingImport } from './routes/_authenticated/_onboarding'
import { Route as AuthenticatedEulaImport } from './routes/_authenticated/_eula'
import { Route as AuthenticatedDirectoryImport } from './routes/_authenticated/_directory'
import { Route as AuthenticatedSettingsIndexImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedScreenerScreenerIdImport } from './routes/_authenticated/screener/$screenerId'
import { Route as AuthenticatedAssessmentAssessmentIdImport } from './routes/_authenticated/assessment/$assessmentId'
import { Route as AuthenticatedUserUserDashboardImport } from './routes/_authenticated/_user/user.dashboard'
import { Route as AuthenticatedOrganizationOrganizationRosterImport } from './routes/_authenticated/_organization/organization.roster'
import { Route as AuthenticatedOrganizationOrganizationDashboardImport } from './routes/_authenticated/_organization/organization.dashboard'
import { Route as AuthenticatedOnboardingOnboardingWholenessScreenerImport } from './routes/_authenticated/_onboarding/onboarding.wholeness-screener'
import { Route as AuthenticatedOnboardingOnboardingUserImport } from './routes/_authenticated/_onboarding/onboarding.user'
import { Route as AuthenticatedOnboardingOnboardingOrganizationImport } from './routes/_authenticated/_onboarding/onboarding.organization'
import { Route as AuthenticatedEulaEulaUpdateImport } from './routes/_authenticated/_eula/eula.update'
import { Route as AuthenticatedUserProfileUserProfileImport } from './routes/_authenticated/_user/_profile/user.profile'
import { Route as AuthenticatedDirectoryTherapistDirectoryTherapistImport } from './routes/_authenticated/_directory/_therapist/directory.therapist'
import { Route as AuthenticatedDirectoryPeerSupportDirectoryPeerSupportImport } from './routes/_authenticated/_directory/_peer-support/directory.peer-support'
import { Route as AuthenticatedDirectoryMemberCareDirectoryMemberCareImport } from './routes/_authenticated/_directory/_member-care/directory.member-care'
import { Route as AuthenticatedUserProfileUserProfileDemographicsImport } from './routes/_authenticated/_user/_profile/user.profile_.demographics'
import { Route as AuthenticatedUserProfileUserProfileContactImport } from './routes/_authenticated/_user/_profile/user.profile_.contact'
import { Route as AuthenticatedDirectoryTherapistDirectoryTherapistTherapistIdImport } from './routes/_authenticated/_directory/_therapist/directory.therapist_.$therapistId'
import { Route as AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdImport } from './routes/_authenticated/_directory/_peer-support/directory.peer-support_.$peerSupportId'
import { Route as AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdImport } from './routes/_authenticated/_directory/_member-care/directory.member-care_.$memberCareId'

// Create/Update Routes

const TermsOfUseRoute = TermsOfUseImport.update({
  path: '/terms-of-use',
  getParentRoute: () => rootRoute,
} as any)

const PrivacyPolicyRoute = PrivacyPolicyImport.update({
  path: '/privacy-policy',
  getParentRoute: () => rootRoute,
} as any)

const ContactSupportRoute = ContactSupportImport.update({
  path: '/contact-support',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const SignInIndexRoute = SignInIndexImport.update({
  path: '/sign-in/',
  getParentRoute: () => rootRoute,
} as any)

const LoginIndexRoute = LoginIndexImport.update({
  path: '/login/',
  getParentRoute: () => rootRoute,
} as any)

const ForgotPasswordIndexRoute = ForgotPasswordIndexImport.update({
  path: '/forgot-password/',
  getParentRoute: () => rootRoute,
} as any)

const PasswordSetupAuthTokenRoute = PasswordSetupAuthTokenImport.update({
  path: '/password-setup/$authToken',
  getParentRoute: () => rootRoute,
} as any)

const PasswordChangeAuthTokenRoute = PasswordChangeAuthTokenImport.update({
  path: '/password-change/$authToken',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedUserRoute = AuthenticatedUserImport.update({
  id: '/_user',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedPeerSupportRoute = AuthenticatedPeerSupportImport.update({
  id: '/_peer-support',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedOrganizationRoute = AuthenticatedOrganizationImport.update({
  id: '/_organization',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedOnboardingRoute = AuthenticatedOnboardingImport.update({
  id: '/_onboarding',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedEulaRoute = AuthenticatedEulaImport.update({
  id: '/_eula',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedDirectoryRoute = AuthenticatedDirectoryImport.update({
  id: '/_directory',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedSettingsIndexRoute = AuthenticatedSettingsIndexImport.update(
  {
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any,
)

const AuthenticatedScreenerScreenerIdRoute =
  AuthenticatedScreenerScreenerIdImport.update({
    path: '/screener/$screenerId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedAssessmentAssessmentIdRoute =
  AuthenticatedAssessmentAssessmentIdImport.update({
    path: '/assessment/$assessmentId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

const AuthenticatedUserUserDashboardRoute =
  AuthenticatedUserUserDashboardImport.update({
    path: '/user/dashboard',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedOrganizationOrganizationRosterRoute =
  AuthenticatedOrganizationOrganizationRosterImport.update({
    path: '/organization/roster',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)

const AuthenticatedOrganizationOrganizationDashboardRoute =
  AuthenticatedOrganizationOrganizationDashboardImport.update({
    path: '/organization/dashboard',
    getParentRoute: () => AuthenticatedOrganizationRoute,
  } as any)

const AuthenticatedOnboardingOnboardingWholenessScreenerRoute =
  AuthenticatedOnboardingOnboardingWholenessScreenerImport.update({
    path: '/onboarding/wholeness-screener',
    getParentRoute: () => AuthenticatedOnboardingRoute,
  } as any)

const AuthenticatedOnboardingOnboardingUserRoute =
  AuthenticatedOnboardingOnboardingUserImport.update({
    path: '/onboarding/user',
    getParentRoute: () => AuthenticatedOnboardingRoute,
  } as any)

const AuthenticatedOnboardingOnboardingOrganizationRoute =
  AuthenticatedOnboardingOnboardingOrganizationImport.update({
    path: '/onboarding/organization',
    getParentRoute: () => AuthenticatedOnboardingRoute,
  } as any)

const AuthenticatedEulaEulaUpdateRoute =
  AuthenticatedEulaEulaUpdateImport.update({
    path: '/eula/update',
    getParentRoute: () => AuthenticatedEulaRoute,
  } as any)

const AuthenticatedUserProfileUserProfileRoute =
  AuthenticatedUserProfileUserProfileImport.update({
    path: '/user/profile',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedDirectoryTherapistDirectoryTherapistRoute =
  AuthenticatedDirectoryTherapistDirectoryTherapistImport.update({
    path: '/directory/therapist',
    getParentRoute: () => AuthenticatedDirectoryRoute,
  } as any)

const AuthenticatedDirectoryPeerSupportDirectoryPeerSupportRoute =
  AuthenticatedDirectoryPeerSupportDirectoryPeerSupportImport.update({
    path: '/directory/peer-support',
    getParentRoute: () => AuthenticatedDirectoryRoute,
  } as any)

const AuthenticatedDirectoryMemberCareDirectoryMemberCareRoute =
  AuthenticatedDirectoryMemberCareDirectoryMemberCareImport.update({
    path: '/directory/member-care',
    getParentRoute: () => AuthenticatedDirectoryRoute,
  } as any)

const AuthenticatedUserProfileUserProfileDemographicsRoute =
  AuthenticatedUserProfileUserProfileDemographicsImport.update({
    path: '/user/profile/demographics',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedUserProfileUserProfileContactRoute =
  AuthenticatedUserProfileUserProfileContactImport.update({
    path: '/user/profile/contact',
    getParentRoute: () => AuthenticatedUserRoute,
  } as any)

const AuthenticatedDirectoryTherapistDirectoryTherapistTherapistIdRoute =
  AuthenticatedDirectoryTherapistDirectoryTherapistTherapistIdImport.update({
    path: '/directory/therapist/$therapistId',
    getParentRoute: () => AuthenticatedDirectoryRoute,
  } as any)

const AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdRoute =
  AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdImport.update(
    {
      path: '/directory/peer-support/$peerSupportId',
      getParentRoute: () => AuthenticatedDirectoryRoute,
    } as any,
  )

const AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdRoute =
  AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdImport.update({
    path: '/directory/member-care/$memberCareId',
    getParentRoute: () => AuthenticatedDirectoryRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/contact-support': {
      id: '/contact-support'
      path: '/contact-support'
      fullPath: '/contact-support'
      preLoaderRoute: typeof ContactSupportImport
      parentRoute: typeof rootRoute
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyImport
      parentRoute: typeof rootRoute
    }
    '/terms-of-use': {
      id: '/terms-of-use'
      path: '/terms-of-use'
      fullPath: '/terms-of-use'
      preLoaderRoute: typeof TermsOfUseImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/_directory': {
      id: '/_authenticated/_directory'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedDirectoryImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/_eula': {
      id: '/_authenticated/_eula'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedEulaImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/_onboarding': {
      id: '/_authenticated/_onboarding'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedOnboardingImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/_organization': {
      id: '/_authenticated/_organization'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedOrganizationImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/_peer-support': {
      id: '/_authenticated/_peer-support'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedPeerSupportImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/_user': {
      id: '/_authenticated/_user'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedUserImport
      parentRoute: typeof AuthenticatedImport
    }
    '/password-change/$authToken': {
      id: '/password-change/$authToken'
      path: '/password-change/$authToken'
      fullPath: '/password-change/$authToken'
      preLoaderRoute: typeof PasswordChangeAuthTokenImport
      parentRoute: typeof rootRoute
    }
    '/password-setup/$authToken': {
      id: '/password-setup/$authToken'
      path: '/password-setup/$authToken'
      fullPath: '/password-setup/$authToken'
      preLoaderRoute: typeof PasswordSetupAuthTokenImport
      parentRoute: typeof rootRoute
    }
    '/forgot-password/': {
      id: '/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordIndexImport
      parentRoute: typeof rootRoute
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginIndexImport
      parentRoute: typeof rootRoute
    }
    '/sign-in/': {
      id: '/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInIndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/assessment/$assessmentId': {
      id: '/_authenticated/assessment/$assessmentId'
      path: '/assessment/$assessmentId'
      fullPath: '/assessment/$assessmentId'
      preLoaderRoute: typeof AuthenticatedAssessmentAssessmentIdImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/screener/$screenerId': {
      id: '/_authenticated/screener/$screenerId'
      path: '/screener/$screenerId'
      fullPath: '/screener/$screenerId'
      preLoaderRoute: typeof AuthenticatedScreenerScreenerIdImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsIndexImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/_eula/eula/update': {
      id: '/_authenticated/_eula/eula/update'
      path: '/eula/update'
      fullPath: '/eula/update'
      preLoaderRoute: typeof AuthenticatedEulaEulaUpdateImport
      parentRoute: typeof AuthenticatedEulaImport
    }
    '/_authenticated/_onboarding/onboarding/organization': {
      id: '/_authenticated/_onboarding/onboarding/organization'
      path: '/onboarding/organization'
      fullPath: '/onboarding/organization'
      preLoaderRoute: typeof AuthenticatedOnboardingOnboardingOrganizationImport
      parentRoute: typeof AuthenticatedOnboardingImport
    }
    '/_authenticated/_onboarding/onboarding/user': {
      id: '/_authenticated/_onboarding/onboarding/user'
      path: '/onboarding/user'
      fullPath: '/onboarding/user'
      preLoaderRoute: typeof AuthenticatedOnboardingOnboardingUserImport
      parentRoute: typeof AuthenticatedOnboardingImport
    }
    '/_authenticated/_onboarding/onboarding/wholeness-screener': {
      id: '/_authenticated/_onboarding/onboarding/wholeness-screener'
      path: '/onboarding/wholeness-screener'
      fullPath: '/onboarding/wholeness-screener'
      preLoaderRoute: typeof AuthenticatedOnboardingOnboardingWholenessScreenerImport
      parentRoute: typeof AuthenticatedOnboardingImport
    }
    '/_authenticated/_organization/organization/dashboard': {
      id: '/_authenticated/_organization/organization/dashboard'
      path: '/organization/dashboard'
      fullPath: '/organization/dashboard'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationDashboardImport
      parentRoute: typeof AuthenticatedOrganizationImport
    }
    '/_authenticated/_organization/organization/roster': {
      id: '/_authenticated/_organization/organization/roster'
      path: '/organization/roster'
      fullPath: '/organization/roster'
      preLoaderRoute: typeof AuthenticatedOrganizationOrganizationRosterImport
      parentRoute: typeof AuthenticatedOrganizationImport
    }
    '/_authenticated/_user/user/dashboard': {
      id: '/_authenticated/_user/user/dashboard'
      path: '/user/dashboard'
      fullPath: '/user/dashboard'
      preLoaderRoute: typeof AuthenticatedUserUserDashboardImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated/_directory/_member-care/directory/member-care': {
      id: '/_authenticated/_directory/_member-care/directory/member-care'
      path: '/directory/member-care'
      fullPath: '/directory/member-care'
      preLoaderRoute: typeof AuthenticatedDirectoryMemberCareDirectoryMemberCareImport
      parentRoute: typeof AuthenticatedDirectoryImport
    }
    '/_authenticated/_directory/_peer-support/directory/peer-support': {
      id: '/_authenticated/_directory/_peer-support/directory/peer-support'
      path: '/directory/peer-support'
      fullPath: '/directory/peer-support'
      preLoaderRoute: typeof AuthenticatedDirectoryPeerSupportDirectoryPeerSupportImport
      parentRoute: typeof AuthenticatedDirectoryImport
    }
    '/_authenticated/_directory/_therapist/directory/therapist': {
      id: '/_authenticated/_directory/_therapist/directory/therapist'
      path: '/directory/therapist'
      fullPath: '/directory/therapist'
      preLoaderRoute: typeof AuthenticatedDirectoryTherapistDirectoryTherapistImport
      parentRoute: typeof AuthenticatedDirectoryImport
    }
    '/_authenticated/_user/_profile/user/profile': {
      id: '/_authenticated/_user/_profile/user/profile'
      path: '/user/profile'
      fullPath: '/user/profile'
      preLoaderRoute: typeof AuthenticatedUserProfileUserProfileImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated/_directory/_member-care/directory/member-care/$memberCareId': {
      id: '/_authenticated/_directory/_member-care/directory/member-care/$memberCareId'
      path: '/directory/member-care/$memberCareId'
      fullPath: '/directory/member-care/$memberCareId'
      preLoaderRoute: typeof AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdImport
      parentRoute: typeof AuthenticatedDirectoryImport
    }
    '/_authenticated/_directory/_peer-support/directory/peer-support/$peerSupportId': {
      id: '/_authenticated/_directory/_peer-support/directory/peer-support/$peerSupportId'
      path: '/directory/peer-support/$peerSupportId'
      fullPath: '/directory/peer-support/$peerSupportId'
      preLoaderRoute: typeof AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdImport
      parentRoute: typeof AuthenticatedDirectoryImport
    }
    '/_authenticated/_directory/_therapist/directory/therapist/$therapistId': {
      id: '/_authenticated/_directory/_therapist/directory/therapist/$therapistId'
      path: '/directory/therapist/$therapistId'
      fullPath: '/directory/therapist/$therapistId'
      preLoaderRoute: typeof AuthenticatedDirectoryTherapistDirectoryTherapistTherapistIdImport
      parentRoute: typeof AuthenticatedDirectoryImport
    }
    '/_authenticated/_user/_profile/user/profile/contact': {
      id: '/_authenticated/_user/_profile/user/profile/contact'
      path: '/user/profile/contact'
      fullPath: '/user/profile/contact'
      preLoaderRoute: typeof AuthenticatedUserProfileUserProfileContactImport
      parentRoute: typeof AuthenticatedUserImport
    }
    '/_authenticated/_user/_profile/user/profile/demographics': {
      id: '/_authenticated/_user/_profile/user/profile/demographics'
      path: '/user/profile/demographics'
      fullPath: '/user/profile/demographics'
      preLoaderRoute: typeof AuthenticatedUserProfileUserProfileDemographicsImport
      parentRoute: typeof AuthenticatedUserImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedDirectoryRouteChildren {
  AuthenticatedDirectoryMemberCareDirectoryMemberCareRoute: typeof AuthenticatedDirectoryMemberCareDirectoryMemberCareRoute
  AuthenticatedDirectoryPeerSupportDirectoryPeerSupportRoute: typeof AuthenticatedDirectoryPeerSupportDirectoryPeerSupportRoute
  AuthenticatedDirectoryTherapistDirectoryTherapistRoute: typeof AuthenticatedDirectoryTherapistDirectoryTherapistRoute
  AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdRoute: typeof AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdRoute
  AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdRoute: typeof AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdRoute
  AuthenticatedDirectoryTherapistDirectoryTherapistTherapistIdRoute: typeof AuthenticatedDirectoryTherapistDirectoryTherapistTherapistIdRoute
}

const AuthenticatedDirectoryRouteChildren: AuthenticatedDirectoryRouteChildren =
  {
    AuthenticatedDirectoryMemberCareDirectoryMemberCareRoute:
      AuthenticatedDirectoryMemberCareDirectoryMemberCareRoute,
    AuthenticatedDirectoryPeerSupportDirectoryPeerSupportRoute:
      AuthenticatedDirectoryPeerSupportDirectoryPeerSupportRoute,
    AuthenticatedDirectoryTherapistDirectoryTherapistRoute:
      AuthenticatedDirectoryTherapistDirectoryTherapistRoute,
    AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdRoute:
      AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdRoute,
    AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdRoute:
      AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdRoute,
    AuthenticatedDirectoryTherapistDirectoryTherapistTherapistIdRoute:
      AuthenticatedDirectoryTherapistDirectoryTherapistTherapistIdRoute,
  }

const AuthenticatedDirectoryRouteWithChildren =
  AuthenticatedDirectoryRoute._addFileChildren(
    AuthenticatedDirectoryRouteChildren,
  )

interface AuthenticatedEulaRouteChildren {
  AuthenticatedEulaEulaUpdateRoute: typeof AuthenticatedEulaEulaUpdateRoute
}

const AuthenticatedEulaRouteChildren: AuthenticatedEulaRouteChildren = {
  AuthenticatedEulaEulaUpdateRoute: AuthenticatedEulaEulaUpdateRoute,
}

const AuthenticatedEulaRouteWithChildren =
  AuthenticatedEulaRoute._addFileChildren(AuthenticatedEulaRouteChildren)

interface AuthenticatedOnboardingRouteChildren {
  AuthenticatedOnboardingOnboardingOrganizationRoute: typeof AuthenticatedOnboardingOnboardingOrganizationRoute
  AuthenticatedOnboardingOnboardingUserRoute: typeof AuthenticatedOnboardingOnboardingUserRoute
  AuthenticatedOnboardingOnboardingWholenessScreenerRoute: typeof AuthenticatedOnboardingOnboardingWholenessScreenerRoute
}

const AuthenticatedOnboardingRouteChildren: AuthenticatedOnboardingRouteChildren =
  {
    AuthenticatedOnboardingOnboardingOrganizationRoute:
      AuthenticatedOnboardingOnboardingOrganizationRoute,
    AuthenticatedOnboardingOnboardingUserRoute:
      AuthenticatedOnboardingOnboardingUserRoute,
    AuthenticatedOnboardingOnboardingWholenessScreenerRoute:
      AuthenticatedOnboardingOnboardingWholenessScreenerRoute,
  }

const AuthenticatedOnboardingRouteWithChildren =
  AuthenticatedOnboardingRoute._addFileChildren(
    AuthenticatedOnboardingRouteChildren,
  )

interface AuthenticatedOrganizationRouteChildren {
  AuthenticatedOrganizationOrganizationDashboardRoute: typeof AuthenticatedOrganizationOrganizationDashboardRoute
  AuthenticatedOrganizationOrganizationRosterRoute: typeof AuthenticatedOrganizationOrganizationRosterRoute
}

const AuthenticatedOrganizationRouteChildren: AuthenticatedOrganizationRouteChildren =
  {
    AuthenticatedOrganizationOrganizationDashboardRoute:
      AuthenticatedOrganizationOrganizationDashboardRoute,
    AuthenticatedOrganizationOrganizationRosterRoute:
      AuthenticatedOrganizationOrganizationRosterRoute,
  }

const AuthenticatedOrganizationRouteWithChildren =
  AuthenticatedOrganizationRoute._addFileChildren(
    AuthenticatedOrganizationRouteChildren,
  )

interface AuthenticatedUserRouteChildren {
  AuthenticatedUserUserDashboardRoute: typeof AuthenticatedUserUserDashboardRoute
  AuthenticatedUserProfileUserProfileRoute: typeof AuthenticatedUserProfileUserProfileRoute
  AuthenticatedUserProfileUserProfileContactRoute: typeof AuthenticatedUserProfileUserProfileContactRoute
  AuthenticatedUserProfileUserProfileDemographicsRoute: typeof AuthenticatedUserProfileUserProfileDemographicsRoute
}

const AuthenticatedUserRouteChildren: AuthenticatedUserRouteChildren = {
  AuthenticatedUserUserDashboardRoute: AuthenticatedUserUserDashboardRoute,
  AuthenticatedUserProfileUserProfileRoute:
    AuthenticatedUserProfileUserProfileRoute,
  AuthenticatedUserProfileUserProfileContactRoute:
    AuthenticatedUserProfileUserProfileContactRoute,
  AuthenticatedUserProfileUserProfileDemographicsRoute:
    AuthenticatedUserProfileUserProfileDemographicsRoute,
}

const AuthenticatedUserRouteWithChildren =
  AuthenticatedUserRoute._addFileChildren(AuthenticatedUserRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedDirectoryRoute: typeof AuthenticatedDirectoryRouteWithChildren
  AuthenticatedEulaRoute: typeof AuthenticatedEulaRouteWithChildren
  AuthenticatedOnboardingRoute: typeof AuthenticatedOnboardingRouteWithChildren
  AuthenticatedOrganizationRoute: typeof AuthenticatedOrganizationRouteWithChildren
  AuthenticatedPeerSupportRoute: typeof AuthenticatedPeerSupportRoute
  AuthenticatedUserRoute: typeof AuthenticatedUserRouteWithChildren
  AuthenticatedAssessmentAssessmentIdRoute: typeof AuthenticatedAssessmentAssessmentIdRoute
  AuthenticatedScreenerScreenerIdRoute: typeof AuthenticatedScreenerScreenerIdRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDirectoryRoute: AuthenticatedDirectoryRouteWithChildren,
  AuthenticatedEulaRoute: AuthenticatedEulaRouteWithChildren,
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRouteWithChildren,
  AuthenticatedOrganizationRoute: AuthenticatedOrganizationRouteWithChildren,
  AuthenticatedPeerSupportRoute: AuthenticatedPeerSupportRoute,
  AuthenticatedUserRoute: AuthenticatedUserRouteWithChildren,
  AuthenticatedAssessmentAssessmentIdRoute:
    AuthenticatedAssessmentAssessmentIdRoute,
  AuthenticatedScreenerScreenerIdRoute: AuthenticatedScreenerScreenerIdRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AuthenticatedUserRouteWithChildren
  '/contact-support': typeof ContactSupportRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-of-use': typeof TermsOfUseRoute
  '/password-change/$authToken': typeof PasswordChangeAuthTokenRoute
  '/password-setup/$authToken': typeof PasswordSetupAuthTokenRoute
  '/forgot-password': typeof ForgotPasswordIndexRoute
  '/login': typeof LoginIndexRoute
  '/sign-in': typeof SignInIndexRoute
  '/assessment/$assessmentId': typeof AuthenticatedAssessmentAssessmentIdRoute
  '/screener/$screenerId': typeof AuthenticatedScreenerScreenerIdRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/eula/update': typeof AuthenticatedEulaEulaUpdateRoute
  '/onboarding/organization': typeof AuthenticatedOnboardingOnboardingOrganizationRoute
  '/onboarding/user': typeof AuthenticatedOnboardingOnboardingUserRoute
  '/onboarding/wholeness-screener': typeof AuthenticatedOnboardingOnboardingWholenessScreenerRoute
  '/organization/dashboard': typeof AuthenticatedOrganizationOrganizationDashboardRoute
  '/organization/roster': typeof AuthenticatedOrganizationOrganizationRosterRoute
  '/user/dashboard': typeof AuthenticatedUserUserDashboardRoute
  '/directory/member-care': typeof AuthenticatedDirectoryMemberCareDirectoryMemberCareRoute
  '/directory/peer-support': typeof AuthenticatedDirectoryPeerSupportDirectoryPeerSupportRoute
  '/directory/therapist': typeof AuthenticatedDirectoryTherapistDirectoryTherapistRoute
  '/user/profile': typeof AuthenticatedUserProfileUserProfileRoute
  '/directory/member-care/$memberCareId': typeof AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdRoute
  '/directory/peer-support/$peerSupportId': typeof AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdRoute
  '/directory/therapist/$therapistId': typeof AuthenticatedDirectoryTherapistDirectoryTherapistTherapistIdRoute
  '/user/profile/contact': typeof AuthenticatedUserProfileUserProfileContactRoute
  '/user/profile/demographics': typeof AuthenticatedUserProfileUserProfileDemographicsRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AuthenticatedUserRouteWithChildren
  '/contact-support': typeof ContactSupportRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-of-use': typeof TermsOfUseRoute
  '/password-change/$authToken': typeof PasswordChangeAuthTokenRoute
  '/password-setup/$authToken': typeof PasswordSetupAuthTokenRoute
  '/forgot-password': typeof ForgotPasswordIndexRoute
  '/login': typeof LoginIndexRoute
  '/sign-in': typeof SignInIndexRoute
  '/assessment/$assessmentId': typeof AuthenticatedAssessmentAssessmentIdRoute
  '/screener/$screenerId': typeof AuthenticatedScreenerScreenerIdRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/eula/update': typeof AuthenticatedEulaEulaUpdateRoute
  '/onboarding/organization': typeof AuthenticatedOnboardingOnboardingOrganizationRoute
  '/onboarding/user': typeof AuthenticatedOnboardingOnboardingUserRoute
  '/onboarding/wholeness-screener': typeof AuthenticatedOnboardingOnboardingWholenessScreenerRoute
  '/organization/dashboard': typeof AuthenticatedOrganizationOrganizationDashboardRoute
  '/organization/roster': typeof AuthenticatedOrganizationOrganizationRosterRoute
  '/user/dashboard': typeof AuthenticatedUserUserDashboardRoute
  '/directory/member-care': typeof AuthenticatedDirectoryMemberCareDirectoryMemberCareRoute
  '/directory/peer-support': typeof AuthenticatedDirectoryPeerSupportDirectoryPeerSupportRoute
  '/directory/therapist': typeof AuthenticatedDirectoryTherapistDirectoryTherapistRoute
  '/user/profile': typeof AuthenticatedUserProfileUserProfileRoute
  '/directory/member-care/$memberCareId': typeof AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdRoute
  '/directory/peer-support/$peerSupportId': typeof AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdRoute
  '/directory/therapist/$therapistId': typeof AuthenticatedDirectoryTherapistDirectoryTherapistTherapistIdRoute
  '/user/profile/contact': typeof AuthenticatedUserProfileUserProfileContactRoute
  '/user/profile/demographics': typeof AuthenticatedUserProfileUserProfileDemographicsRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/contact-support': typeof ContactSupportRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-of-use': typeof TermsOfUseRoute
  '/_authenticated/_directory': typeof AuthenticatedDirectoryRouteWithChildren
  '/_authenticated/_eula': typeof AuthenticatedEulaRouteWithChildren
  '/_authenticated/_onboarding': typeof AuthenticatedOnboardingRouteWithChildren
  '/_authenticated/_organization': typeof AuthenticatedOrganizationRouteWithChildren
  '/_authenticated/_peer-support': typeof AuthenticatedPeerSupportRoute
  '/_authenticated/_user': typeof AuthenticatedUserRouteWithChildren
  '/password-change/$authToken': typeof PasswordChangeAuthTokenRoute
  '/password-setup/$authToken': typeof PasswordSetupAuthTokenRoute
  '/forgot-password/': typeof ForgotPasswordIndexRoute
  '/login/': typeof LoginIndexRoute
  '/sign-in/': typeof SignInIndexRoute
  '/_authenticated/assessment/$assessmentId': typeof AuthenticatedAssessmentAssessmentIdRoute
  '/_authenticated/screener/$screenerId': typeof AuthenticatedScreenerScreenerIdRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/_eula/eula/update': typeof AuthenticatedEulaEulaUpdateRoute
  '/_authenticated/_onboarding/onboarding/organization': typeof AuthenticatedOnboardingOnboardingOrganizationRoute
  '/_authenticated/_onboarding/onboarding/user': typeof AuthenticatedOnboardingOnboardingUserRoute
  '/_authenticated/_onboarding/onboarding/wholeness-screener': typeof AuthenticatedOnboardingOnboardingWholenessScreenerRoute
  '/_authenticated/_organization/organization/dashboard': typeof AuthenticatedOrganizationOrganizationDashboardRoute
  '/_authenticated/_organization/organization/roster': typeof AuthenticatedOrganizationOrganizationRosterRoute
  '/_authenticated/_user/user/dashboard': typeof AuthenticatedUserUserDashboardRoute
  '/_authenticated/_directory/_member-care/directory/member-care': typeof AuthenticatedDirectoryMemberCareDirectoryMemberCareRoute
  '/_authenticated/_directory/_peer-support/directory/peer-support': typeof AuthenticatedDirectoryPeerSupportDirectoryPeerSupportRoute
  '/_authenticated/_directory/_therapist/directory/therapist': typeof AuthenticatedDirectoryTherapistDirectoryTherapistRoute
  '/_authenticated/_user/_profile/user/profile': typeof AuthenticatedUserProfileUserProfileRoute
  '/_authenticated/_directory/_member-care/directory/member-care/$memberCareId': typeof AuthenticatedDirectoryMemberCareDirectoryMemberCareMemberCareIdRoute
  '/_authenticated/_directory/_peer-support/directory/peer-support/$peerSupportId': typeof AuthenticatedDirectoryPeerSupportDirectoryPeerSupportPeerSupportIdRoute
  '/_authenticated/_directory/_therapist/directory/therapist/$therapistId': typeof AuthenticatedDirectoryTherapistDirectoryTherapistTherapistIdRoute
  '/_authenticated/_user/_profile/user/profile/contact': typeof AuthenticatedUserProfileUserProfileContactRoute
  '/_authenticated/_user/_profile/user/profile/demographics': typeof AuthenticatedUserProfileUserProfileDemographicsRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/contact-support'
    | '/privacy-policy'
    | '/terms-of-use'
    | '/password-change/$authToken'
    | '/password-setup/$authToken'
    | '/forgot-password'
    | '/login'
    | '/sign-in'
    | '/assessment/$assessmentId'
    | '/screener/$screenerId'
    | '/settings'
    | '/eula/update'
    | '/onboarding/organization'
    | '/onboarding/user'
    | '/onboarding/wholeness-screener'
    | '/organization/dashboard'
    | '/organization/roster'
    | '/user/dashboard'
    | '/directory/member-care'
    | '/directory/peer-support'
    | '/directory/therapist'
    | '/user/profile'
    | '/directory/member-care/$memberCareId'
    | '/directory/peer-support/$peerSupportId'
    | '/directory/therapist/$therapistId'
    | '/user/profile/contact'
    | '/user/profile/demographics'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/contact-support'
    | '/privacy-policy'
    | '/terms-of-use'
    | '/password-change/$authToken'
    | '/password-setup/$authToken'
    | '/forgot-password'
    | '/login'
    | '/sign-in'
    | '/assessment/$assessmentId'
    | '/screener/$screenerId'
    | '/settings'
    | '/eula/update'
    | '/onboarding/organization'
    | '/onboarding/user'
    | '/onboarding/wholeness-screener'
    | '/organization/dashboard'
    | '/organization/roster'
    | '/user/dashboard'
    | '/directory/member-care'
    | '/directory/peer-support'
    | '/directory/therapist'
    | '/user/profile'
    | '/directory/member-care/$memberCareId'
    | '/directory/peer-support/$peerSupportId'
    | '/directory/therapist/$therapistId'
    | '/user/profile/contact'
    | '/user/profile/demographics'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/contact-support'
    | '/privacy-policy'
    | '/terms-of-use'
    | '/_authenticated/_directory'
    | '/_authenticated/_eula'
    | '/_authenticated/_onboarding'
    | '/_authenticated/_organization'
    | '/_authenticated/_peer-support'
    | '/_authenticated/_user'
    | '/password-change/$authToken'
    | '/password-setup/$authToken'
    | '/forgot-password/'
    | '/login/'
    | '/sign-in/'
    | '/_authenticated/assessment/$assessmentId'
    | '/_authenticated/screener/$screenerId'
    | '/_authenticated/settings/'
    | '/_authenticated/_eula/eula/update'
    | '/_authenticated/_onboarding/onboarding/organization'
    | '/_authenticated/_onboarding/onboarding/user'
    | '/_authenticated/_onboarding/onboarding/wholeness-screener'
    | '/_authenticated/_organization/organization/dashboard'
    | '/_authenticated/_organization/organization/roster'
    | '/_authenticated/_user/user/dashboard'
    | '/_authenticated/_directory/_member-care/directory/member-care'
    | '/_authenticated/_directory/_peer-support/directory/peer-support'
    | '/_authenticated/_directory/_therapist/directory/therapist'
    | '/_authenticated/_user/_profile/user/profile'
    | '/_authenticated/_directory/_member-care/directory/member-care/$memberCareId'
    | '/_authenticated/_directory/_peer-support/directory/peer-support/$peerSupportId'
    | '/_authenticated/_directory/_therapist/directory/therapist/$therapistId'
    | '/_authenticated/_user/_profile/user/profile/contact'
    | '/_authenticated/_user/_profile/user/profile/demographics'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ContactSupportRoute: typeof ContactSupportRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  TermsOfUseRoute: typeof TermsOfUseRoute
  PasswordChangeAuthTokenRoute: typeof PasswordChangeAuthTokenRoute
  PasswordSetupAuthTokenRoute: typeof PasswordSetupAuthTokenRoute
  ForgotPasswordIndexRoute: typeof ForgotPasswordIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  SignInIndexRoute: typeof SignInIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ContactSupportRoute: ContactSupportRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  TermsOfUseRoute: TermsOfUseRoute,
  PasswordChangeAuthTokenRoute: PasswordChangeAuthTokenRoute,
  PasswordSetupAuthTokenRoute: PasswordSetupAuthTokenRoute,
  ForgotPasswordIndexRoute: ForgotPasswordIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  SignInIndexRoute: SignInIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_authenticated",
        "/contact-support",
        "/privacy-policy",
        "/terms-of-use",
        "/password-change/$authToken",
        "/password-setup/$authToken",
        "/forgot-password/",
        "/login/",
        "/sign-in/"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/_directory",
        "/_authenticated/_eula",
        "/_authenticated/_onboarding",
        "/_authenticated/_organization",
        "/_authenticated/_peer-support",
        "/_authenticated/_user",
        "/_authenticated/assessment/$assessmentId",
        "/_authenticated/screener/$screenerId",
        "/_authenticated/settings/"
      ]
    },
    "/contact-support": {
      "filePath": "contact-support.tsx"
    },
    "/privacy-policy": {
      "filePath": "privacy-policy.tsx"
    },
    "/terms-of-use": {
      "filePath": "terms-of-use.tsx"
    },
    "/_authenticated/_directory": {
      "filePath": "_authenticated/_directory.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/_directory/_member-care/directory/member-care",
        "/_authenticated/_directory/_peer-support/directory/peer-support",
        "/_authenticated/_directory/_therapist/directory/therapist",
        "/_authenticated/_directory/_member-care/directory/member-care/$memberCareId",
        "/_authenticated/_directory/_peer-support/directory/peer-support/$peerSupportId",
        "/_authenticated/_directory/_therapist/directory/therapist/$therapistId"
      ]
    },
    "/_authenticated/_eula": {
      "filePath": "_authenticated/_eula.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/_eula/eula/update"
      ]
    },
    "/_authenticated/_onboarding": {
      "filePath": "_authenticated/_onboarding.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/_onboarding/onboarding/organization",
        "/_authenticated/_onboarding/onboarding/user",
        "/_authenticated/_onboarding/onboarding/wholeness-screener"
      ]
    },
    "/_authenticated/_organization": {
      "filePath": "_authenticated/_organization.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/_organization/organization/dashboard",
        "/_authenticated/_organization/organization/roster"
      ]
    },
    "/_authenticated/_peer-support": {
      "filePath": "_authenticated/_peer-support.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/_user": {
      "filePath": "_authenticated/_user.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/_user/user/dashboard",
        "/_authenticated/_user/_profile/user/profile",
        "/_authenticated/_user/_profile/user/profile/contact",
        "/_authenticated/_user/_profile/user/profile/demographics"
      ]
    },
    "/password-change/$authToken": {
      "filePath": "password-change/$authToken.tsx"
    },
    "/password-setup/$authToken": {
      "filePath": "password-setup/$authToken.tsx"
    },
    "/forgot-password/": {
      "filePath": "forgot-password/index.tsx"
    },
    "/login/": {
      "filePath": "login/index.tsx"
    },
    "/sign-in/": {
      "filePath": "sign-in/index.tsx"
    },
    "/_authenticated/assessment/$assessmentId": {
      "filePath": "_authenticated/assessment/$assessmentId.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/screener/$screenerId": {
      "filePath": "_authenticated/screener/$screenerId.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings/": {
      "filePath": "_authenticated/settings/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/_eula/eula/update": {
      "filePath": "_authenticated/_eula/eula.update.tsx",
      "parent": "/_authenticated/_eula"
    },
    "/_authenticated/_onboarding/onboarding/organization": {
      "filePath": "_authenticated/_onboarding/onboarding.organization.tsx",
      "parent": "/_authenticated/_onboarding"
    },
    "/_authenticated/_onboarding/onboarding/user": {
      "filePath": "_authenticated/_onboarding/onboarding.user.tsx",
      "parent": "/_authenticated/_onboarding"
    },
    "/_authenticated/_onboarding/onboarding/wholeness-screener": {
      "filePath": "_authenticated/_onboarding/onboarding.wholeness-screener.tsx",
      "parent": "/_authenticated/_onboarding"
    },
    "/_authenticated/_organization/organization/dashboard": {
      "filePath": "_authenticated/_organization/organization.dashboard.tsx",
      "parent": "/_authenticated/_organization"
    },
    "/_authenticated/_organization/organization/roster": {
      "filePath": "_authenticated/_organization/organization.roster.tsx",
      "parent": "/_authenticated/_organization"
    },
    "/_authenticated/_user/user/dashboard": {
      "filePath": "_authenticated/_user/user.dashboard.tsx",
      "parent": "/_authenticated/_user"
    },
    "/_authenticated/_directory/_member-care/directory/member-care": {
      "filePath": "_authenticated/_directory/_member-care/directory.member-care.tsx",
      "parent": "/_authenticated/_directory"
    },
    "/_authenticated/_directory/_peer-support/directory/peer-support": {
      "filePath": "_authenticated/_directory/_peer-support/directory.peer-support.tsx",
      "parent": "/_authenticated/_directory"
    },
    "/_authenticated/_directory/_therapist/directory/therapist": {
      "filePath": "_authenticated/_directory/_therapist/directory.therapist.tsx",
      "parent": "/_authenticated/_directory"
    },
    "/_authenticated/_user/_profile/user/profile": {
      "filePath": "_authenticated/_user/_profile/user.profile.tsx",
      "parent": "/_authenticated/_user"
    },
    "/_authenticated/_directory/_member-care/directory/member-care/$memberCareId": {
      "filePath": "_authenticated/_directory/_member-care/directory.member-care_.$memberCareId.tsx",
      "parent": "/_authenticated/_directory"
    },
    "/_authenticated/_directory/_peer-support/directory/peer-support/$peerSupportId": {
      "filePath": "_authenticated/_directory/_peer-support/directory.peer-support_.$peerSupportId.tsx",
      "parent": "/_authenticated/_directory"
    },
    "/_authenticated/_directory/_therapist/directory/therapist/$therapistId": {
      "filePath": "_authenticated/_directory/_therapist/directory.therapist_.$therapistId.tsx",
      "parent": "/_authenticated/_directory"
    },
    "/_authenticated/_user/_profile/user/profile/contact": {
      "filePath": "_authenticated/_user/_profile/user.profile_.contact.tsx",
      "parent": "/_authenticated/_user"
    },
    "/_authenticated/_user/_profile/user/profile/demographics": {
      "filePath": "_authenticated/_user/_profile/user.profile_.demographics.tsx",
      "parent": "/_authenticated/_user"
    }
  }
}
ROUTE_MANIFEST_END */
